import { useEffect } from 'react';
import posthogClient from '../../shared/posthogClient';

const posthogEventForFunnel = {
  subscribe: { event: 'signup_modal_details', reason: 'clicked_unlock_now' },
  paywall_reached: { event: 'signup_modal_details', reason: 'out_of_free_searches' },
  continue_access: { event: 'shown_continue_access_modal', reason: 'out_of_free_searches_unverified' },
  out_of_daily_searches: { event: 'shown_upgrade_for_more_searches_modal', reason: 'out_of_daily_searches' },
  coupon: { event: 'shown_coupon_modal' },
  expired_with_valid_card: { event: 'shown_expired_with_valid_card_modal' },
  expired_with_invalid_card: { event: 'shown_expired_with_invalid_card_modal' },
  out_of_ranking_lists: { event: 'shown_ranking_upgrade_modal' },
  curious_about_ranking_lists: { event: 'shown_ranking_upgrade_modal' },
  curious_about_even_more_ranking_lists: { event: 'gold_wants_more_lists_shown_contact_support_modal' },
};

export default function usePosthog(funnel, metadata = {}) {
  useEffect(() => {
    const entry = posthogEventForFunnel[funnel];
    if (entry) posthogClient.capture(entry.event, { funnel, ...(entry.reason && { reason: entry.reason }), ...metadata });
  }, [funnel]);
}
